import { useEffect, useRef } from "react";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);

    if (!match) {
      window.location.replace("/");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await exchangeSession(sessionId);
        // Hard reload a /dashboard — limpia hash y fuerza AuthProvider a refrescar via cookie
        window.location.replace("/dashboard");
      } catch (e) {
        console.error("Auth exchange failed", e);
        window.location.replace("/?auth_error=1");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full bg-foreground mx-auto grid place-items-center mb-5">
          <Loader2 className="w-6 h-6 animate-spin text-white" />
        </div>
        <p className="font-display text-xl font-black">Entrando a Strato…</p>
        <p className="text-sm text-foreground/65 mt-1">Un segundo.</p>
      </div>
    </div>
  );
}
